import { useState, useRef } from "react";
import { refreshAliyunToken, getTokenInfo } from "../utils/request";

export const useAliyunOffice = (unit_id, course_id) => {
  // 文件预览sdk逻辑
  const [isAliyun, setIsAliyun] = useState(false); // 文件类型
  const [WebofficeURL, setWebofficeURL] = useState(""); // 预览链接
  const [isNoFile, setIsNoFile] = useState(false); // 是否出错
  const [isNoAccess, setIsNoAccess] = useState(false); // 是否没有权限
  const [isAvailable, setIsAvailable] = useState(false); // 是否加载完毕
  let lastTokenInfo = useRef()
  let instance = useRef()
  if (unit_id === null || course_id === null) return
  const timeout = 32 * 60 * 1000 // 阿里云sdk会提前五分钟, 所以此处设置为33分钟
  function setLastTokenInfo(tokenInfo) {
    const _lastTokenInfo = lastTokenInfo.current = {
      "RefreshToken": tokenInfo.refresh_token || tokenInfo.RefreshToken,
      "RequestId": tokenInfo.request_id || tokenInfo.RequestId,
      "AccessToken": tokenInfo.access_token || tokenInfo.AccessToken,
      "RefreshTokenExpiredTime": tokenInfo.refresh_token_expired_time || tokenInfo.RefreshTokenExpiredTime,
      "WebofficeURL": tokenInfo.weboffice_url || tokenInfo.WebofficeURL,
      "AccessTokenExpiredTime": tokenInfo.access_token_expired_time || tokenInfo.AccessTokenExpiredTime
    }
    if (_lastTokenInfo && _lastTokenInfo.RefreshToken === '') {
      setIsNoFile(true)
    } else {
      setIsNoFile(false)
    }
  }

  // 刷新token
  function refreshToken() {
    let params = {
      course_id: course_id,
      AccessToken: lastTokenInfo.current.AccessToken,
    }
    if (unit_id !== null && unit_id !== '0') {
      params.unit_id = unit_id
    }
    console.log(params, 'params')
    return new Promise(function(resolve){
      //业务处理逻辑，调用服务端封装的refreshToken接口。
      refreshAliyunToken(params).then(function(res){
        const tokenInfo = res.data
        console.log(tokenInfo, '收到的tokenInfo')
        setLastTokenInfo(tokenInfo)
        resolve({
          token: tokenInfo.AccessToken, //必须设置。
          timeout, // 必须设置，Token超时时间，单位为ms，示例设置超时时间为25分钟。可配合refreshToken配置函数使用，在超时前5分钟调用refreshToken重新刷新Token。
        })
      })
    })
  }

  // 动态导入ali的sdk
  async function initSdk (el) {
    if (!lastTokenInfo.current || !lastTokenInfo.current.WebofficeURL) {
      // throw new Error('lastTokenInfo内容缺失')
    }
    const aliyun = window.aliyun
    // 1. 初始化SDK
    if (!instance.current) {
      instance.current = aliyun.config({
        mode: 'simple',
        mount: el,
        url: lastTokenInfo.current.WebofficeURL,
        refreshToken,
        isIframeViewFullscreen: true,
        pptOptions: {
          isShowRemarkView: false, // 隐藏备注视图, 该功能问题颇多, 尤其是观众模式分屏后, 原屏幕会出现无编辑权限提示
        },
        commandBars: [
          {
            cmbId: 'ToolBarFullScreenBtn', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: true, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
        ]
      })
    } else {
      reStore(el)
      return
    }
    if (!instance.current) return
    // 2. 设置过期后的token
    instance.current.setToken({
      token: lastTokenInfo.current.AccessToken,
      timeout,
    })
    instance.current.on('error', (e) => {
      if (e.reason === 'PermissionRevoked') {
        setIsNoAccess(true)
      }
      console.log(e, 'error事件')
    })
    instance.current.on('fileOpen', function(data) {
      console.log(data, 'open');
      setIsAvailable(true)
    });
    await instance.current.ready();
    const app = instance.current.Application;
    //显示隐藏工具栏
    app.ActivePresentation.SlideShowSettings.ShowPlayToolbar = false;
    //窗口对象
    // Slide设置对象
    const SlideShowSettings = await app.ActivePresentation.SlideShowSettings;
    // 进入幻灯片播放模式
    await SlideShowSettings.Run();
    const SlideShowWindow = await app.ActivePresentation.SlideShowWindow;
    //视图对象
    const view = await SlideShowWindow.View;
    //播放模式下显示页码
    view.ShowPage = true;
    // //跳转到指定页
    // app.ActivePresentation.SlideShowWindow.View.GotoSlide(1);
  }

  // 判断是否使用阿里云sdk
  function checkAliyunSdk (selector, unit_id, bool, isSeries) {
    if (bool) {
      setIsAliyun(true)
      const el = document.querySelector(selector)
      // 是否是系列课程
      if (isSeries) {
        getTokenInfo(unit_id).then(res => {
          if (res.status === 200) {
            const data = res.data
            setLastTokenInfo(data)
            if (!data.WebofficeURL) return
            setWebofficeURL(data.WebofficeURL)
            initSdk(el);
          }
        })
      } else {
        initSdk(el);
        // getTokenInfoByCourseId(course_id).then(res => {
        //   if (res.status === 200) {
        //     const data = res.data
        //     setLastTokenInfo(data)
        //     if (!data.WebofficeURL) return
        //     setWebofficeURL(data.WebofficeURL)
        //     initSdk(el);
        //   }
        // })
      }
    } else {
      setIsAliyun(false)
    }
  }
  async function reStart(el) {
    if (isNoAccess) {
      setIsNoAccess(false)
      instance.current = null
      initSdk(el)
    }
  }
  async function reStore(el) {
    instance.current = null
    initSdk(el)
  }
  return {
    isAliyun,
    checkAliyunSdk,
    setLastTokenInfo,
    WebofficeURL,
    setWebofficeURL,
    isNoFile, // 是否错误(没有文件)
    isNoAccess, // 是否没有权限(暂时离开)
    reStart,
    isAvailable
  }
}